import React from 'react'
import Image from 'next/image'
import Link from 'next/link'
import { Header } from '../index'
import {
  appstorewhitebtn,
  googlewhitebtn,
  brandlogo,
  brandlogowhite,
} from '../../assets'
import styles from './producthero.module.css'

const ProductHero = () => {
  return (
    <div className={styles.firstFrame}>
      <Header
        brand={brandlogowhite}
        linkStyles={styles.linkStyles}
        mobileBrand={brandlogo}
        brandToggle={brandlogo}
      />

      <div className={styles.firstFramewrapper}></div>
      <div className={styles.estateheaderBody}>
        <div className={styles.headerBodyleft}>
          <div className={styles.usecase}>product</div>
          <div className={styles.headerBodylefttextsbuttons}>
            <div className={styles.headerBodylefttexts}>
              <p className={styles.toplefttext}>
                Manage It all from one system built for Every business
              </p>
              <p className={styles.bottomlefttext}>
                Manage All Your Back Store, Front Store, and Inventory
                Operations with Circleplug
              </p>
            </div>
            <div className={styles.platformbuttons}>
              <Link
                target={'_blank'}
                className={styles.platformbutton}
                href={`https://apps.apple.com/ng/app/circleplug/id6462672418`}
              >
                <Image src={appstorewhitebtn} alt='app store button' />
              </Link>
              <Link
                target={'_blank'}
                className={styles.platformbutton}
                href={`https://play.google.com/store/apps/details?id=com.shypes.circlePlug`}
              >
                <Image src={googlewhitebtn} alt='google play button' />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProductHero
